import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      profile: null,
      isAuthenticated: false,
      loading: true,

      setUser: (user) => set({ user, isAuthenticated: !!user }),
      
      setProfile: (profile) => set({ profile }),
      
      clearAuth: () => set({ 
        user: null, 
        profile: null, 
        isAuthenticated: false 
      }),
      
      setLoading: (loading) => set({ loading }),

      // Check if profile is complete
      isProfileComplete: () => {
        const { profile } = get();
        return profile && profile.profileCompleted;
      }
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({ 
        user: state.user, 
        profile: state.profile,
        isAuthenticated: state.isAuthenticated 
      }),
    }
  )
);

export default useAuthStore;